import { environment } from '../../../../../../environments/environment';
import { Quotation } from '../../../../../sale/model';
const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
const currencyCode = user ? user.user.currencyCode : '';

  export const approveQuotation = {
    show: 'Seleccione las cotizaciones pendientes de aprobar',
    columns: [
      {
        title: 'N° Cotización',
        name: 'quotationNumber',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.quotationNumber
      },
      {
        title: 'Estado',
        name: 'origin',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.state.capitalize()
      },
      {
        title: 'Vigencia hasta',
        name: 'validUntil',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.validUntil
      },
      {
        title: 'Método de pago',
        name: 'paymentMethodId',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.paymentMethod
      },
      {
        title: 'Comentarios',
        name: 'comments',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.comments
      },
      {
        title: 'Observaciones',
        name: 'observations',
        type: 'string',
        class: 'left',
        value: (element: Quotation) => element.quotationInfo.observations
      },
      {
        title: 'Autorizaciones pendientes',
        name: 'permissions',
        type: 'string',
        class: 'left',
        value: (element: any) => element.quotationInfo.permissionsText
      },
      {
        title: 'Monto',
        name: 'price',
        type: 'string',
        class: 'right',
        value: (element: Quotation) =>  `${currencyCode}/${element.quotationInfo.totalAmount}`
      }
    ]
  };